export default __webpack_public_path__ + "static/media/scooter-title@2x.697b9607.png";